import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Tag } from "../../../interfaces/tag";

@Component({
	selector: "app-tag",
	standalone: true,
	templateUrl: "./tag.component.html",
	styleUrls: ["./tag.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [],
})
export class TagComponent {
	@Input() tags: Tag[] = [];
	@Input() maxTags: number = 0;

	get displayedTags(): Tag[] {
		if (this.maxTags === 0) {
			return this.tags;
		}
		return this.tags.slice(0, this.maxTags);
	}

	get hasMore(): boolean {
		return this.maxTags > 0 && this.tags.length > this.maxTags;
	}
}
